var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuroLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 365.053 161.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Exclusion_7",
    x: 188.126,
    y: 77.282,
    width: 95.927,
    height: 53.82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Exclusion_8",
    x: 269.127,
    y: 77.28,
    width: 95.925,
    height: 53.819,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2025",
    x: 0,
    y: 0,
    width: 144.264,
    height: 157.365,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2026",
    x: 64.396,
    y: 50.69,
    width: 88.165,
    height: 110.411,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2228",
    x: 117.562,
    y: 77.281,
    width: 88.564,
    height: 53.819,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(-228.642 -444.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 228.64, 444.9)",
    filter: "url(#Exclusion_7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_7-2",
    "data-name": "Exclusion 7",
    d: "M-452.066-11053.18H-467l5.6-29.5a5.614,5.614,0,0,1,1.241-2.461,10.968,10.968,0,0,1,2.8-2.1,10.072,10.072,0,0,1,3.749-1.4,15.171,15.171,0,0,1,4.044-.364h50.728a16.537,16.537,0,0,1,4.366.364,8.6,8.6,0,0,1,3.1,1.4,5.943,5.943,0,0,1,1.862,2.1l.028.065a3.149,3.149,0,0,1,.267,2.4l-1.859,10.541a5.634,5.634,0,0,1-1.241,2.461,11.025,11.025,0,0,1-2.8,2.095,10.059,10.059,0,0,1-3.746,1.4,15.186,15.186,0,0,1-4.044.364h-5.9l14.311,12.639-18.06,0-14.933-12.641h-22.292l-2.29,12.641Zm5.291-27.636h0l-1.177,7.416h46.011l1.353-7.416h-46.186Z",
    transform: "translate(664.13 11172.28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 228.64, 444.9)",
    filter: "url(#Exclusion_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_8-2",
    "data-name": "Exclusion 8",
    d: "M-405.432-11053.181h-51.429a16.493,16.493,0,0,1-4.375-.364l-.241-.07a10.066,10.066,0,0,1-3.187-1.327,2.012,2.012,0,0,0-.161-.122l-.008-.006c-.05-.036-.1-.073-.154-.117l-.076-.058a3.38,3.38,0,0,1-1.491-1.823,3.223,3.223,0,0,1-.323-2.463l4.4-23.148a5.939,5.939,0,0,1,1.241-2.461,11,11,0,0,1,2.808-2.1,9.627,9.627,0,0,1,3.754-1.4,15.218,15.218,0,0,1,4.049-.364h51.454a16.493,16.493,0,0,1,4.375.364l.234.068a10.058,10.058,0,0,1,3.195,1.329,5.446,5.446,0,0,1,1.862,2.1l.028.065a3.141,3.141,0,0,1,.27,2.4l-4.372,23.179a6,6,0,0,1-1.244,2.463,10.964,10.964,0,0,1-2.808,2.1,9.591,9.591,0,0,1-3.751,1.4A15.218,15.218,0,0,1-405.432-11053.181Zm-40.9-27.223h0l-3.142,18.623h39.741l3.142-18.623Z",
    transform: "translate(745.13 11172.28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(-208.851 294.571)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 437.49, 150.33)",
    filter: "url(#Path_2025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2025-2",
    "data-name": "Path 2025",
    d: "M87.136,7.963C89.9,6.369,124.4-1.022,126.239.12S31.97,129.914,28.377,133.254.394,140.7,0,138.948,84.384,9.563,87.136,7.963",
    transform: "translate(9 6)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 437.49, 150.33)",
    filter: "url(#Path_2026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2026-2",
    "data-name": "Path 2026",
    d: "M30.43,76.857c-1.07-2.9,15.993-24.878,15.993-24.878s19.905-26.252,22.5-27.663,16,1.172,15.575,3.6S56.838,63.9,61.19,72.417s39.883,43.06,39.351,43.828-28.763-4.152-30.5-5.2S31.5,79.761,30.43,76.857",
    transform: "translate(43.02 32.77)",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 228.64, 444.9)",
    filter: "url(#Path_2228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2228-2",
    "data-name": "Path 2228",
    d: "M74.144,37.483H59.95L54.62,66.957a3.225,3.225,0,0,0,.306,2.458A3.274,3.274,0,0,0,56.413,71.3a1.226,1.226,0,0,1,.281.245,9.4,9.4,0,0,0,3.256,1.4A14.771,14.771,0,0,0,64.1,73.3h44.688a13.674,13.674,0,0,0,3.843-.367,9.291,9.291,0,0,0,3.562-1.4,10.478,10.478,0,0,0,2.665-2.094,5.8,5.8,0,0,0,1.178-2.458l5.021-29.474H110.863l-4.741,27.377H69.4Z",
    transform: "translate(72.07 45.8)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuroLogoFull);
export default __webpack_public_path__ + "static/media/kuroLogoFull.6748ced23fd638f4e02313faf2569887.svg";
export { ForwardRef as ReactComponent };